'use strict';

var React = require('react');

var SvgCursorOptionIcon = function SvgCursorOptionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.25v3.75c0 .414.336.75.75.75s.75-.336.75-.75v-3.75c0-2.071-1.679-3.75-3.75-3.75h-5.5c-2.071 0-3.75 1.679-3.75 3.75v5.5c0 2.071 1.679 3.75 3.75 3.75h3.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.75c-1.243 0-2.25-1.007-2.25-2.25v-5.5c0-1.243 1.007-2.25 2.25-2.25h5.5c1.243 0 2.25 1.007 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.75c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.75c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.75c0-.414.336-.75.75-.75h2.25c.414 0 .75.336.75.75s-.336.75-.75.75h-2.25c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.216 12.216c.124-.124.304-.174.474-.132l4.51 1.122c.175.043.314.178.362.351.048.174-.001.36-.129.487l-1.164 1.165.841.84c.195.196.195.512 0 .708l-.353.353c-.196.196-.512.196-.707 0l-.841-.84-1.165 1.164c-.127.127-.313.176-.487.128-.174-.048-.308-.186-.351-.361l-1.122-4.51c-.042-.171.008-.35.132-.475Z"
  }));
};
SvgCursorOptionIcon.displayName = "CursorOptionIcon";

exports.SvgCursorOptionIcon = SvgCursorOptionIcon;
